import styled, {css, DefaultTheme} from 'styled-components'
import {InputWrapper} from '@/components/ui/input-wrapper/InputWrapper'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {CSSProperties} from 'react'

export const StyledInputText = styled(Flexbox)<{$width: CSSProperties['width']}>(
    ({$width}) => css`
        width: ${$width};
    `
)

export const StyledInputTextGroup = styled(Flexbox)<{$hasError: boolean; $disabled?: boolean}>(
    ({theme: {shadows}, $hasError, $disabled = false}) => css`
        box-shadow: ${$hasError || $disabled ? 'none' : shadows.sm};
        border-radius: 8px;
        &:hover {
            box-shadow: none;
        }
    `
)

export const makeInputSizeStyle = ({spacing}: DefaultTheme) => ({
    sm: css`
        height: 28px;
        padding: 0 ${spacing * 1.5}px 0 ${spacing * 1.5}px;
    `,
    md: css`
        height: 32px;
        padding: 0 ${spacing * 2}px 0 ${spacing * 2}px;
    `,
    lg: css`
        height: 36px;
        padding: 0 ${spacing * 2.5}px 0 ${spacing * 2.5}px;
    `
})

export const StyledInputWrapper = styled(InputWrapper)<{$size: 'sm' | 'md' | 'lg'}>(
    ({theme, $size}) => makeInputSizeStyle(theme)[$size]
)

export const makeInputBaseStyle = (theme: DefaultTheme) => css`
    flex: 1;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    color: ${theme.palette.neutral['950']};
    ${theme.typography.textSm}

    &:focus {
        outline: none;
    }
    &::placeholder {
        color: ${theme.palette.neutral['400']};
    }
    &:disabled {
        cursor: not-allowed;
        color: ${theme.palette.neutral['400']};
    }
`

export const StyledInput = styled.input`
    ${({theme}) => css`
        ${makeInputBaseStyle(theme)}
    `}
`

type StyledVisibleToggleProps = {
    $disabled?: boolean
    $size: 'sm' | 'md' | 'lg'
}
export const StyledVisibleToggle = styled.div<StyledVisibleToggleProps>`
    ${({$disabled, theme: {palette}}) => css`
        display: flex;
        align-items: center;
        background: ${palette.neutral.white};
        color: ${palette.neutral['700']};
        cursor: ${$disabled ? 'not-allowed' : 'pointer'};
        outline: 1px solid ${palette.neutral['300']};
        border-radius: 0 8px 8px 0;
        outline-left: none;
    `}
    ${({$size, theme}) => VisibleToggleSizeStyles(theme)[$size]};
`

const VisibleToggleSizeStyles = ({spacing}: DefaultTheme) => ({
    sm: css`
        height: 28px;
        padding: ${spacing * 2}px ${spacing * 2}px;
    `,
    md: css`
        height: 32px;
        padding: ${spacing * 2.5}px ${spacing * 2}px;
    `,
    lg: css`
        height: 36px;
        padding: ${spacing * 2}px ${spacing * 2}px;
    `
})
